import React, { useEffect, useState } from "react";
import { Select, Descriptions, Spin, TreeSelect } from "antd";
import { createComponentStore } from "easy-peasy";
import { Controller } from "react-hook-form";
import {
  ParameterStoreModel,
  ACTION_TYPES,
} from "store/models/parameters/general-parameter";

var arrayToTree = require("array-to-tree");

export default function DeedTypeSelect({
  form,
  field,
  defaultValue,
  disabled,
  labelInValue,
  style,
  allowClear = true,
  onlyRoot = false,
  ...props
}) {
  const useStore = createComponentStore(ParameterStoreModel("dedtypes"));
  const [store, actions] = useStore();
  const [data, setData] = useState([]);

  useEffect(() => {
    actions.fetch();
  }, []);

  useEffect(() => {
    if (store.data) {
      let list = store.data.map((item) => ({
        parentCode: item.code.substring(0, item.code.lastIndexOf(".")),
        children: [],
        title: item.code + " - " + item.description,
        code: item.code,
        value: item.id,
      }));

      setData(
        arrayToTree(list, {
          parentProperty: "parentCode",
          childrenProperty: "children",
          customID: "code",
        })
      );
    }
  }, [store.data]);

  return (
    <Controller
      defaultValue={defaultValue}
      control={form.control}
      name={field}
      render={({ onChange, onBlur, name, value }) => (
        <TreeSelect
          {...props}
          name={name}
          value={value?.id}
          allowClear={allowClear}
          disabled={props.readOnly}
          onBlur={onBlur}
          onChange={(value) => {
            value = store.data.find((f) => f.id == value);
            if (value)
              value.root = {
                ...store.data.find((f) => f.code == value?.code?.charAt(0)),
              };
            onChange(value);
          }}
          treeData={
            onlyRoot
              ? data.map((m) => ({
                  children: [],
                  code: m.code,
                  parentCode: m.code,
                  title: m.title,
                  value: m.value,
                }))
              : data
          }
          showSearch
          filterOption={(input, option) =>
            option.title.toLowerCase().includes(input.toLowerCase())
          }
          style={style || { width: "100%" }}
          treeDefaultExpandAll
        />
      )}
    />
  );
}
